import * as React from 'react';

export function RewardIcon() {
  return (
    <svg fill="none" height={12} width={12} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.25 1.875a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 1 1 3.75 0v.004c0 .053 0 .203-.028.371h1.528A.75.75 0 0 1 12 3v.75a.75.75 0 0 1-.75.75H.75A.75.75 0 0 1 0 3.75V3a.75.75 0 0 1 .75-.75h1.529a2.25 2.25 0 0 1-.029-.37v-.005Zm.801.375H5.25v-.375a1.125 1.125 0 1 0-2.25 0c0 .064.002.205.034.322l.017.053Zm3.699 0h2.199l.017-.053C9 2.08 9 1.94 9 1.875a1.125 1.125 0 0 0-2.25 0v.375Zm4.5 3v5.625A1.125 1.125 0 0 1 10.125 12H6.75V5.25h4.5ZM1.875 12A1.125 1.125 0 0 1 .75 10.875V5.25h4.5V12H1.875Z"
        fill="#E7CD2E"
      />
    </svg>
  );
}
